import React from 'react';
import { Route, Switch } from 'react-router-dom';
import AccessControl from '../../../../AccessControl';
import {
  PERMISSIONS_KEY,
  PERMISSION_TYPE,
  ROUTES,
} from '../../../../common/constants';
import Error404 from '../../../../Error404';
import CreateDelivery from './pages/CreateSalesTeam';
import EditDelivery from './pages/EditDelivery';
import Delivery from './pages/SalesTeam';
import ViewDelivery from './pages/ViewSalesTeam';

const SalesTeamWrapper = () => (
  <Switch>
    <Route
      exact
      path={`${ROUTES?.SYSTEM_USERS}${ROUTES?.SALES_TEAM}`}
      render={(props) => (
        <AccessControl
          permissionKey={PERMISSIONS_KEY?.SYSTEM_USERS_DELIVERY_PARTNERS}
        >
          <Delivery {...props} />
        </AccessControl>
      )}
    />
    <Route
      exact
      path={`${ROUTES?.SYSTEM_USERS}${ROUTES?.SALES_TEAM}/add`}
      render={(props) => (
        <AccessControl
          permissionType={PERMISSION_TYPE?.CREATE}
          permissionKey={PERMISSIONS_KEY?.SYSTEM_USERS_DELIVERY_PARTNERS}
        >
          <CreateDelivery {...props} />
        </AccessControl>
      )}
    />
    <Route
      exact
      path={`${ROUTES?.SYSTEM_USERS}${ROUTES?.SALES_TEAM}/edit/:id`}
      render={(props) => (
        <AccessControl
          permissionType={PERMISSION_TYPE?.UPDATE}
          permissionKey={PERMISSIONS_KEY?.SYSTEM_USERS_DELIVERY_PARTNERS}
        >
          <EditDelivery {...props} />
        </AccessControl>
      )}
    />
    <Route
      exact
      path={`${ROUTES?.SYSTEM_USERS}${ROUTES?.SALES_TEAM}/view/:id`}
      render={(props) => (
        <AccessControl
          permissionKey={PERMISSIONS_KEY?.SYSTEM_USERS_DELIVERY_PARTNERS}
        >
          <ViewDelivery {...props} />
        </AccessControl>
      )}
    />
    <Route path="*" exact component={Error404} />
  </Switch>
);

export default SalesTeamWrapper;
